import { useEffect, useState } from 'react';
import { productApi } from '../api/productApi';

const AdminProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [imgFile, setImgFile] = useState(null);

  const [form, setForm] = useState({
    id: null,
    name: '',
    description: '',
    category_id: '',
    image_url: '',
  });

  useEffect(() => {
    fetchCategories();
    fetchProducts();
  }, []);

  const fetchCategories = async () => {
  try {
    const data = await productApi.getCategories();
    setCategories(data || []);
  } catch (err) {
    console.error(err);
  }
};

  const fetchProducts = async () => {
  setLoading(true);

  try {
    const data = await productApi.getAll();
    setProducts(data || []);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const resetForm = () => {
    setForm({
      id: null,
      name: '',
      description: '',
      category_id: '',
      image_url: '',
    });

    setImgFile(null);
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!form.name.trim()) {
    alert('Vui lòng nhập tên sản phẩm');
    return;
  }

  if (!form.category_id) {
    alert('Vui lòng chọn danh mục');
    return;
  }

  try {
    const formData = new FormData();

    formData.append('name', form.name);
    formData.append('description', form.description);
    formData.append('category_id', form.category_id);

    if (imgFile) {
      formData.append('image', imgFile);
    }

    let response;

    if (form.id) {
      response = await productApi.update(form.id, formData);
    } else {
      response = await productApi.create(formData);
    }

    if (response.error) {
      alert(response.error);
      return;
    }

    alert(
      form.id
        ? 'Cập nhật thành công'
        : 'Thêm sản phẩm thành công'
    );

    resetForm();
    fetchProducts();
  } catch (err) {
    console.error(err);
    alert('Có lỗi xảy ra');
  }
};

  const handleEdit = (product) => {
    setForm({
      id: product.id,
      name: product.name || '',
      description: product.description || '',
      category_id: product.category_id || '',
      image_url: product.image_url || '',
    });

    setImgFile(null);

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleDelete = async (id) => {
  const confirmDelete = window.confirm(
    'Bạn có chắc muốn xóa sản phẩm?'
  );

  if (!confirmDelete) return;

  try {
    await productApi.delete(id);
    fetchProducts();
  } catch (err) {
    console.error(err);
  }
};

  return (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-amber-900 p-6">
    {/* Background Effects */}
    <div className="absolute top-20 left-10 w-72 h-72 bg-amber-500/10 rounded-full blur-3xl"></div>
    <div className="absolute bottom-20 right-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl"></div>

    <div className="relative max-w-7xl mx-auto space-y-8">
      {/* Header */}
      <div className="text-white">
        <h1 className="text-4xl font-extrabold mb-2">Quản lý sản phẩm</h1>
        <p className="text-slate-300">
          Thêm, chỉnh sửa và xóa sản phẩm trong hệ thống.
        </p>
      </div>

      {/* Form Card */}
      <div className="backdrop-blur-xl bg-white/95 border border-white/20 rounded-3xl shadow-2xl p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-lg">
            <span className="text-white text-xl">📦</span>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-slate-900">
              {form.id ? 'Cập nhật sản phẩm' : 'Thêm sản phẩm mới'}
            </h2>
            <p className="text-sm text-slate-500">
              Điền đầy đủ thông tin bên dưới.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Row 1 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Product Name */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">
                Tên sản phẩm
              </label>
              <input
                type="text"
                value={form.name}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    name: e.target.value,
                  }))
                }
                placeholder="Nhập tên sản phẩm"
                className="w-full px-4 py-3 rounded-2xl border border-slate-200 bg-slate-50 outline-none transition-all duration-200 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100"
              />
            </div>

            {/* Category */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">
                Danh mục
              </label>
              <select
                value={form.category_id}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    category_id: e.target.value,
                  }))
                }
                className="w-full px-4 py-3 rounded-2xl border border-slate-200 bg-slate-50 outline-none transition-all duration-200 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100"
              >
                <option value="">-- Chọn danh mục --</option>
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Mô tả
            </label>
            <textarea
              value={form.description}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
              rows="4"
              placeholder="Nhập mô tả sản phẩm"
              className="w-full px-4 py-3 rounded-2xl border border-slate-200 bg-slate-50 outline-none resize-none transition-all duration-200 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100"
            />
          </div>

          {/* Image Upload */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Ảnh sản phẩm
            </label>

            <label className="flex flex-col items-center justify-center w-full border-2 border-dashed border-slate-300 rounded-2xl bg-slate-50 hover:bg-slate-100 cursor-pointer transition-all py-8">
              <span className="text-4xl mb-2">🖼️</span>
              <span className="text-sm font-medium text-slate-600">
                Chọn ảnh từ máy tính
              </span>
              <span className="text-xs text-slate-400 mt-1">
                JPG, PNG, WEBP
              </span>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImgFile(e.target.files[0])}
                className="hidden"
              />
            </label>
          </div>

          {/* Image Preview */}
          {(imgFile || form.image_url) && (
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-3">
                Xem trước ảnh
              </label>
              <div className="inline-block p-2 bg-slate-50 rounded-2xl border border-slate-200">
                <img
                  src={
                    imgFile
                      ? URL.createObjectURL(imgFile)
                      : form.image_url
                  }
                  alt="preview"
                  className="w-40 h-40 object-cover rounded-xl"
                />
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex flex-wrap gap-3 pt-2">
            <button
              type="submit"
              className="px-6 py-3 rounded-2xl bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold shadow-lg shadow-amber-500/30 hover:shadow-xl hover:shadow-amber-500/40 hover:scale-[1.02] transition-all duration-200"
            >
              {form.id ? 'Cập nhật sản phẩm' : 'Thêm sản phẩm'}
            </button>

            <button
              type="button"
              onClick={resetForm}
              className="px-6 py-3 rounded-2xl bg-slate-200 text-slate-700 font-semibold hover:bg-slate-300 transition-all duration-200"
            >
              Reset
            </button>
          </div>
        </form>
      </div>

      {/* Products Table Card */}
      <div className="backdrop-blur-xl bg-white/95 border border-white/20 rounded-3xl shadow-2xl overflow-hidden">
        <div className="px-8 py-6 border-b border-slate-100">
          <h2 className="text-2xl font-bold text-slate-900">
            Danh sách sản phẩm
          </h2>
          <p className="text-sm text-slate-500 mt-1">
            Tổng cộng {products.length} sản phẩm
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px]">
            <thead className="bg-slate-50">
              <tr className="text-left">
                <th className="px-6 py-4 text-sm font-semibold text-slate-600">
                  Ảnh
                </th>
                <th className="px-6 py-4 text-sm font-semibold text-slate-600">
                  Tên sản phẩm
                </th>
                <th className="px-6 py-4 text-sm font-semibold text-slate-600">
                  Danh mục
                </th>
                <th className="px-6 py-4 text-sm font-semibold text-slate-600">
                  Mô tả
                </th>
                <th className="px-6 py-4 text-sm font-semibold text-slate-600">
                  Hành động
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100">
              {loading ? (
                <tr>
                  <td
                    colSpan="5"
                    className="px-6 py-12 text-center text-slate-500"
                  >
                    Đang tải dữ liệu...
                  </td>
                </tr>
              ) : products.length === 0 ? (
                <tr>
                  <td
                    colSpan="5"
                    className="px-6 py-12 text-center text-slate-500"
                  >
                    Chưa có sản phẩm nào.
                  </td>
                </tr>
              ) : (
                products.map((product) => (
                  <tr
                    key={product.id}
                    className="hover:bg-slate-50 transition-colors"
                  >
                    {/* Image */}
                    <td className="px-6 py-4">
                      {product.image_url ? (
                        <img
                          src={product.image_url}
                          alt={product.name}
                          className="w-20 h-20 object-cover rounded-2xl border border-slate-200 shadow-sm"
                        />
                      ) : (
                        <div className="w-20 h-20 rounded-2xl bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-400 text-xs text-center">
                          Không có ảnh
                        </div>
                      )}
                    </td>

                    {/* Name */}
                    <td className="px-6 py-4 font-semibold text-slate-900">
                      {product.name}
                    </td>

                    {/* Category */}
                    <td className="px-6 py-4">
                      <span className="inline-flex px-3 py-1 rounded-full bg-amber-100 text-amber-700 text-sm font-medium">
                        {product.categories?.name || 'Chưa phân loại'}
                      </span>
                    </td>

                    {/* Description */}
                    <td className="px-6 py-4 text-slate-600 max-w-xs">
                      <div className="line-clamp-3">
                        {product.description || 'Không có mô tả'}
                      </div>
                    </td>

                    {/* Actions */}
                    <td className="px-6 py-4">
                      <div className="flex flex-wrap gap-2">
                        <button
                          onClick={() => handleEdit(product)}
                          className="px-4 py-2 rounded-xl bg-amber-500 text-white font-medium hover:bg-amber-600 transition-colors"
                        >
                          Sửa
                        </button>

                        <button
                          onClick={() => handleDelete(product.id)}
                          className="px-4 py-2 rounded-xl bg-red-500 text-white font-medium hover:bg-red-600 transition-colors"
                        >
                          Xóa
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);
};

export default AdminProductsPage;